module.exports = __webpack_public_path__ + "img/edit_enhance.6a8da0b.svg";